
  import { Options, Vue } from 'vue-class-component';
  import HelloWorld from '../../components/HelloWorld.vue';
  import {DataUtil} from '@/util/DataUtil';
  import {agreementConfig} from '@/config/template';

  @Options({
    components: {
      HelloWorld,
    }
  })
  export default class App extends Vue {
    private temp: string = agreementConfig.template;

    private config: TemplateInterface = {
      productName: '我的庄园',
      companyFullName: '海南高宇网络技术有限公司',
      companyShortName: '我的庄园',
    };

    mounted(){
      this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
  }
